import * as Sentry from '@sentry/react'
import { sentryProperties } from 'utils/sentryProperties'

export const sentryIdentify = (user) => {

  Sentry.withScope((scope) => {
    scope.setLevel('error');
    scope.setUser(user);

    Sentry.captureException(new Error(sentryProperties.ERROR_MESSAGE.ERROR));
  });
}